// extracted by mini-css-extract-plugin
export default {"promoLink":"_34e55","active":"_12dD0"};